export default "__VITE_ASSET__mxKErWrt__"